import React from 'react';
import './App.css';
import WebRoutes from './WebRoutes';

function App() {
  return (
    <div className="App">
      <WebRoutes />
    </div>
  );
}

export default App;
